'use strict';

(function () {
  'use strict';

  angular.module('msCore').provider('authenticationRouter', authenticationRouterProvider);
  /* @ngInject */
  function authenticationRouterProvider() {
    var provider = this;
    provider.configure = _configure;
    provider.$get = ['$log', 'httpSvc', '$state', '$sessionStorage', 'msAuth', 'overlaySvc', 'loadingScreenSvc', authenticationRouterFactory];

    function authenticationRouterFactory($log, httpSvc, $state, $sessionStorage, msAuth, overlaySvc, loadingScreenSvc) {
      // NOSONAR
      // Get auth requirements from API if we don't have them in session storage
      if (msAuth.isLoggedIn() && !$sessionStorage.authRequirements) {
        _getAPIAuthRequirements().then(function (requirements) {
          $sessionStorage.authRequirements = requirements ? requirements : [];
        });
      }

      return {
        goToState: _goToState,
        goToNextStep: _goToNextStep,
        markRequirementComplete: _markRequirementComplete,
        getRequirement: _getRequirement,
        clearRequirements: _clearRequirements,
        getCurrentOnboardingStep: _getCurrentOnboardingStep,
        removeLoginStep: _removeLoginStep
      };

      function _getAPIAuthRequirements() {
        return httpSvc.get('/apiproxy/public/user/auth-requirements').then(function (resp) {
          return resp.requirements;
        });
      }

      function _clearRequirements() {
        if ($sessionStorage.authRequirements) {
          delete $sessionStorage.authRequirements;
        }
      }

      /**
       * Fetches the named requirement from sessionStorage
       * @param  {String} req The name of the requirement
       * @return {Object}     The requirement if found, else undefined
       */
      function _getRequirement(req) {
        return _.find($sessionStorage.authRequirements, ['requirementType', req]);
      }

      /**
       * A function that will check to determine if the passed in step fulfills a
       * user authentication requirement and if so, marks that requirement complete.
       * @param  {String} step The state name of the step completed
       */
      function _markRequirementComplete(step) {
        if (provider.requirementMap[step]) {
          var requirement = _.find($sessionStorage.authRequirements, ['requirementType', provider.requirementMap[step]]);
          if (requirement) {
            //if the step had a live requirement, mark it complete
            requirement.complete = true;
          }
        }
      }

      function _getCurrentStepIndex(navigationOrder, currentStep) {
        return _.findIndex(navigationOrder, function (s) {
          return currentStep === s;
        });
      }

      /**
       * The sign-up / login / sso / resume navigation function.
       * This function will track the user's authentication requirements,
       * determine the next step the user should perform and take them there.
       * @param  {Object} args    An object containing any contextual args to pass on
       * @param  {Object} overlay Optional. An object containing any overlay args to use.
       */
      function _goToNextStep(args, overlay) {
        var needed;
        var currentStep = $state.current.name;

        _markRequirementComplete(currentStep);

        while (!needed) {
          var currentStepIndex = _getCurrentStepIndex(provider.defaultNavigationOrder, currentStep);
          var nextStep = provider.defaultNavigationOrder[currentStepIndex + 1];

          //if the nextStep is in our requirement map, only show it if the
          //requirement exists and it's not already complete for the session
          if (provider.requirementMap[nextStep] === 'UNCONDITIONAL') {
            //if we get here, then the step is always shown
            needed = true;
          } else if (provider.requirementMap[nextStep]) {
            var reqStep = _.find($sessionStorage.authRequirements || [], {
              requirementType: provider.requirementMap[nextStep]
            });
            if (reqStep) {
              needed = !reqStep.hasOwnProperty('complete') || reqStep.hasOwnProperty('complete') && reqStep.complete !== true;
            }
          }
          if (needed) {
            //Go there if the step is needed
            _goToState(nextStep, args, overlay);
            loadingScreenSvc.getCreatedLoadingScreen();
          } else {
            //otherwise keep looping until we find a step that is needed
            currentStep = nextStep;
          }
        }
      }
      /**
       * The base wrapper function for state.go in this provider
       * @param  {String} name the destination route name
       * @param  {[type]} args containing an optional message, errorCode
       *                       and a flag denoting if a contact us link
       *                       should be shown
       */
      function _goToState(name, args, overlay) {
        // Only run this hacky block for webView users
        // - $rootScope needs to be grabbed at runtime since is provider
        if (args && args.isMobileWebView) {
          angular.element('body').injector().invoke(['$rootScope', function ($rootScope) {
            if ($rootScope.updateRootToken) {
              $rootScope.updateRootToken();
            }
          }]);
        }

        if (!overlay) {
          $state.go(name, args);
        } else {
          overlaySvc.overlay(overlay.name, {
            redirect: name,
            args: args,
            timeout: 1500,
            overlayTimeout: 3500,
            onboarding: true
          });
        }
      }

      /**
       * Get the current step in the onboarding process, based on the current $state.
       */

      // TODO: Extend provider.requirementMap or provider.defaultNavigationOrder to
      // include the onboarding phase each step belongs to.
      function _getCurrentOnboardingStep() {
        var currentState = $state.current.name;
        var noSteps = ['steps.account', 'steps.agreements', 'steps.terms', 'steps.termsAfter'];
        var step_0 = ['steps.communityGuidelines', 'steps.communityGuidelines'];
        var step_1 = ['steps.survey', 'steps.mood'];
        var step_2 = ['steps.assessment', 'steps.assessment.disclaimer', 'steps.assessment.question', 'steps.assessment.question.questionChild', 'steps.assessment.notice'];
        var step_4 = ['steps.customization', 'steps.thanks', 'done', 'intervention', 'train', 'legacy', 'home'];

        if (_.includes(step_0, currentState)) {
          return 0;
        } else if (_.includes(step_1, currentState)) {
          return 1;
        } else if (_.includes(step_2, currentState)) {
          return 2;
        } else if (_.includes(step_4, currentState)) {
          return 4;
        } else if (_.includes(noSteps, currentState)) {
          return null;
        } else {
          // If the route isn't defined above, log an error but display it without the steps.
          $log.error('Onboarding steps not set up correctly. Current $state: ', $state.current);
          return null;
        }
      }
    }

    function _removeLoginStep() {
      var loginStep = 'login';
      var loginStepIndex = provider.defaultNavigationOrder.indexOf(loginStep);

      if (loginStepIndex !== -1) {
        provider.defaultNavigationOrder.splice(loginStepIndex, 1);
      }
    }

    function _configure(context) {
      //context is either onboarding or login
      provider.context = context || 'onboarding';
      //This is the list of supported, server-driven requirements
      //mapped to their UI routes
      provider.requirementMap = {
        'steps.account': 'UNCONDITIONAL',
        'login': 'UNCONDITIONAL',
        'done': 'UNCONDITIONAL',
        'home': 'UNCONDITIONAL',
        'steps.agreements': 'AGREEMENTS',
        'password': 'PASSWORD_CHANGE',
        'steps.terms': 'TERMS_OF_USE',
        'sso.landing': 'SSO_TERMS_OF_USE',
        'steps.termsAfter': 'TERMS_OF_USE',
        'sso.password': 'SSO_PASSWORD',
        'steps.communityGuidelines': 'COMMUNITY_DISCLAIMER',
        'steps.survey': 'WELLNESS_PROGRAM',
        'steps.thanks': 'WELLNESS_FOCUS',
        'steps.mood': 'TRACKER',
        'sleep.calendar': 'SLEEP_DIARY',
        'sleep.entry-summary': 'SLEEP_DIARY',
        'sleep.schedule-initial': 'SLEEP_INITIAL_SCHEDULE',
        'sleep.needs': 'SLEEP_NEEDS',
        'sleep.schedule': 'SLEEP_NEEDS',
        'sleep.plan': 'SLEEP_PLAN',
        'steps.assessment.notice': 'ASSESSMENT',
        'steps.assessment': 'ASSESSMENT',
        'steps.assessment.question': 'ASSESSMENT',
        'steps.assessment.question.questionChild': 'ASSESSMENT',
        'steps.assessment.disclaimer': 'ASSESSMENT_DISCLAIMER',
        'steps.customization': 'PERSONALIZATION',
        'intervention': 'TRACKER_INTERVENTION',
        'train': 'SHOW_TRAIN',
        'legacy': 'LEGACY'
      };
      //default nav order is for std onboarding
      //The last state should not be in requirement map to ensure some final location
      provider.defaultNavigationOrder = ['steps.terms', 'steps.account', 'sso.landing', 'sso.password', 'steps.termsAfter', 'steps.agreements', 'steps.communityGuidelines', 'steps.survey', 'steps.mood', 'sleep.calendar', 'sleep.entry', 'sleep.entry-summary', 'sleep.schedule-initial', 'sleep.needs', 'sleep.schedule', 'sleep.plan', 'steps.assessment.notice', 'steps.assessment', 'steps.assessment.question', 'steps.assessment.question.questionChild', 'steps.assessment.disclaimer', 'steps.customization', 'steps.thanks', 'done', 'intervention', 'train', 'legacy', 'home'];
      //if the context is login, swap out 'account' for 'login' routes
      if (provider.context === 'login') {
        var accountStep = 'steps.account';
        var accountStepIndex = provider.defaultNavigationOrder.indexOf(accountStep);
        provider.defaultNavigationOrder.splice(accountStepIndex, 1, 'login', 'password');
      }
    }
  }
})();